export enum AnalysisStatus {
  ERROR = 'ERROR',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
}

export interface ErroredAnalysis {
  message: string;
  status: AnalysisStatus.ERROR;
}

export interface LoadingAnalysis {
  status: AnalysisStatus.LOADING;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
interface _SuccessfulAnalysis<T> {
  result: T;
  label?: unknown;
  status: AnalysisStatus.SUCCESS;
}

export type Analysis<T> = ErroredAnalysis | LoadingAnalysis | _SuccessfulAnalysis<T>;

export type SuccessfulAnalysis<AnalysisType extends Analysis<unknown>> = Exclude<
  AnalysisType,
  ErroredAnalysis | LoadingAnalysis
>;

export function areAnalysesSuccessful<AnalysisType extends Analysis<unknown>>(
  analyses: Array<AnalysisType>
): analyses is Array<SuccessfulAnalysis<AnalysisType>> {
  return analyses.every((analysis) => analysis.status === AnalysisStatus.SUCCESS);
}
